import React from 'react';

const steps = [
  { label: 'Account', step: 1 },
  { label: 'Zona e documenti', step: 2 },
  { label: 'Pagamento', step: 3 },
];

const ProgressIndicator = ({ currentStep = 1, totalSteps = 3 }) => {
  return (
    <div className="w-full">
      {/* Step labels */}
      <div className="flex items-center justify-between mb-2">
        {steps?.map((s, idx) => {
          const isCompleted = s?.step < currentStep;
          const isActive = s?.step === currentStep;
          return (
            <span
              key={s?.step}
              className="text-xs font-medium"
              style={{
                color: isCompleted || isActive ? '#2780b5' : '#9ca3af',
                fontWeight: isActive ? 600 : 500,
              }}
            >
              {s?.label}
            </span>
          );
        })}
      </div>
      {/* Progress bar */}
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className="h-2 rounded-full transition-all duration-300"
          style={{
            width: `${(currentStep / totalSteps) * 100}%`,
            backgroundColor: '#2780b5',
          }}
        />
      </div>
    </div>
  );
};

export default ProgressIndicator;